import * as React from "react";

const Compare: React.FC = () => {
    return (
<svg width="51px" height="45px" viewBox="0 0 51 45" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>Icons/Compare</title>
    <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Product-Compare_2-Items" transform="translate(-1105.000000, -556.000000)" stroke="#E5E5E5" stroke-width="2">
            <g id="Product/Product-Card" transform="translate(999.000000, 387.500000)">
                <g id="Icons/Compare" transform="translate(106.000000, 168.500000)">
                    <rect id="Rectangle" x="1" y="8" width="10" height="36"></rect>
                    <rect id="Rectangle" x="20" y="1" width="11" height="43"></rect>
                    <rect id="Rectangle" x="40" y="8" width="10" height="36"></rect>
                </g>
            </g>
        </g>
    </g>
</svg>

    );
};

export default React.memo(Compare);